<template>
    <div>
        <div class="shopping-car-page">
            <!--抬頭-->
            <div class="page_top">
                <div class="title" @click="back()">
                    <i class="icon" id="icon"></i>
                    <span class="header-text">購物車</span>
                </div>
            </div>
            <!--內容頁-->
            <div class="page_padding">
                <div class="container-fluid ">
                    <!--狀態列-->
                    <div class="row">
                        <div class="col-12 my-4">
                            <div class="bg-white p-2 rounded shadow">
                                <el-steps :active="active" finish-status="success" align-center>
                                    <el-step title="確認訂單"></el-step>
                                    <el-step title="確認資料"></el-step>
                                    <el-step title="付款"></el-step>
                                    <el-step title="完成訂單"></el-step>
                                </el-steps>
                            </div>
                        </div>
                    </div>
                    <!--訂單列表-->
                    <div class="row col-12" v-if="loading">
                        <div class="col-12 justify-content-center w-100 align-content-center d-flex">
                            <i class="el-icon-loading"></i>
                        </div>
                    </div>
                    <div v-if="active==0">
                        <!--商家商品顯示-->
                        <div class="bg-white rounded shadow mt-3" v-for=" manufacturer in shoppingCars"
                             :key="manufacturer.id">
                            <!--商家名稱-->
                            <div class="row col-12">
                                <div class="ms-2 my-2">
                                    <el-checkbox v-model="checkAll[manufacturer.id]"
                                                 :indeterminate="isIndeterminate[manufacturer.id]"
                                                 @change="handleCheckAllChange(manufacturer.id)">
                                        <span class="fs-5 fw-bold "
                                              style="color: #212529">{{ manufacturer.name }}</span>
                                    </el-checkbox>
                                </div>
                            </div>
                            <!--商品列表-->
                            <el-checkbox-group v-model="checkedProducts[manufacturer.id]">
                                <div v-for="product in manufacturer.products" :key="product.id" class="mx-1 ">
                                    <div class="row border-bottom p-2 fw-bold">
                                        <div class="col-1 d-flex align-items-center">
                                            <el-checkbox :label="product.productId" class="products_check"
                                                         @change="handleCheckedProductChange(manufacturer.id,product.productId,product.total)"
                                                         :disabled="(product.status==2 || product.status==3)">

                                            </el-checkbox>
                                        </div>
                                        <div class="col-4">
                                            <img :src="product.image" alt="" class="w-100" @error="imgError">

                                        </div>
                                        <div class="col-7 d-flex flex-column" style="font-size: 1rem">
                                            <div class="mb-2 d-flex align-items-center justify-content-between">
                                                <el-tag type="danger" v-if="product.isPreorder==1">預購</el-tag>
                                                <span class="ms-1"
                                                      v-if="product.shipDate>1">保證{{
                                                        product.shipDate
                                                    }}天內發貨</span>
                                            </div>
                                            <span class="mb-2 lh-base ">
                                                {{ product.name }}
                                            </span>
                                            <span class="text-danger my-2">
                                                    {{ product.price }}
                                            </span>
                                            <div class="row">
                                                <div class="col-6">
                                                    <el-select v-model="product.total" filterable placeholder="請選擇"
                                                               size="mini"
                                                               @change="modifyShoppingCar(product.productId,product.total,manufacturer.id)"
                                                               :disabled="(product.status ==2 || product.status ==3)">
                                                        <el-option v-for="number in product.canBuyNumber"
                                                                   :key="number"
                                                                   :label="number" :value="number">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                                <div class="col-6 d-flex justify-content-end">
                                                    <el-button type="danger" size="mini"
                                                               @click="deleteShoppingCar(manufacturer.id,product.productId)"
                                                               :loading="loading">刪除
                                                    </el-button>
                                                </div>
                                            </div>
                                            <span class="text-danger mt-2" v-if="product.status == 2">商品售完</span>
                                            <span class="text-danger mt-2" v-if="product.status == 3">商品停售</span>
                                            <span class="text-danger mt-2"
                                                  v-if="product.status == 4">商品不足，已調整數量</span>
                                        </div>

                                    </div>
                                </div>
                            </el-checkbox-group>
                            <!--運費-->
                            <div class="row col-12">
                                <div class="w-100 ms-3 my-3 fw-bold">
                                    <span>運費：</span><span
                                    class="text-danger">{{ deliveryFees[manufacturer.id]['deliveryFees'] }}</span>
                                </div>
                            </div>
                        </div>
                        <!--總金額-->
                        <div class="row mt-2 p-2" v-if="!loading">
                            <div class="col bg-white  rounded shadow">
                                <div class="row p-2 fs-5 my-3">
                                    <div class="col-12 d-flex justify-content-between">
                                        <span class="fw-bold">總金額</span>
                                        <div>
                                            <span class="mx-3">({{ totalNumber }}個商品)</span>
                                            <span class="fw-bold text-danger ">{{ totalAmount }}</span>
                                        </div>

                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>
                    <!--購買資訊-->
                    <el-form v-if="active ==1" ref="infoForm" :model="form" label-width="80px" :rules="rules"
                             size="small">
                        <div class="mx-2 bg-white shadow ">
                            <div class="row  mx-2">
                                <div class="col-12">
                                    <el-divider content-position="left"><span class="fw-bold">購買人資訊</span>
                                    </el-divider>
                                    <el-form-item label="姓名" prop="buyInfo.name">
                                        <div class="d-flex justify-content-between">
                                            <el-input v-model="form.buyInfo.name" placeholder="姓名"
                                                      @input="setLikeBuyfalse"></el-input>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="聯絡電話" prop="buyInfo.phone">
                                        <el-input type="number" v-model="form.buyInfo.phone"
                                                  placeholder="連絡電話" @input="setLikeBuyfalse"></el-input>
                                    </el-form-item>
                                    <el-form-item label="email" prop="buyInfo.email">
                                        <el-input v-model="form.buyInfo.email"
                                                  placeholder="email"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <!--發票寄送資訊-->
                            <div class="row mx-2">
                                <el-divider content-position="left"><span class="fw-bold">發票寄送資訊</span>
                                </el-divider>
                                <el-form-item label="縣/市" prop="buyInfo.city">
                                    <el-select v-model="form.buyInfo.city" placeholder="地區"
                                               @change="checnagBuyTown(form.buyInfo.city)">
                                        <el-option v-for="county in counties" :label="county.text" :value="county.id"
                                                   :key="county.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="鄉鎮市區" prop="buyInfo.area">
                                    <el-select v-model="form.buyInfo.area" placeholder="鄉鎮市區"
                                               @change="setLikeBuyfalse">
                                        <el-option v-for="town in buyTowns" :label="town.text" :value="town.id"
                                                   :key="town.id"></el-option>
                                        <el-option label="小港區" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="地址" prop="buyInfo.address">
                                    <el-input v-model="form.buyInfo.address" placeholder="地址"
                                              @input="setLikeBuyfalse"></el-input>
                                </el-form-item>
                                <el-form-item label="發票抬頭" prop="buyInfo.companyName">
                                    <el-input v-model="form.buyInfo.companyName" placeholder="發票抬頭"></el-input>
                                </el-form-item>
                                <el-form-item label="統一編號" prop="buyInfo.companyCode">
                                    <el-input v-model="form.buyInfo.companyCode" placeholder="統一編號"></el-input>
                                </el-form-item>
                            </div>
                            <!--配送資訊-->
                            <div class="row  mx-2">
                                <div class="col-12 ">
                                    <el-divider content-position="left"><span class="fw-bold">配送資訊</span>
                                    </el-divider>
                                    <el-row class="mb-3">
                                        <el-checkbox label="與發票寄送資訊相同" name="type" v-model="setLikeBuy"
                                                     @change="setLikeBuyData()"></el-checkbox>
                                    </el-row>
                                    <el-form-item label="姓名" prop="sendInfo.name">
                                        <div class="d-flex justify-content-between">
                                            <el-input v-model="form.sendInfo.name" placeholder="姓名"
                                                      @input="setLikeBuyfalse"></el-input>
                                            <el-tag type="info" @click="setSendData()">常用資料</el-tag>
                                        </div>

                                    </el-form-item>
                                    <el-form-item label="聯絡電話" prop="sendInfo.phone">
                                        <el-input v-model="form.sendInfo.phone" placeholder="連絡電話"
                                                  @input="setLikeBuyfalse"></el-input>
                                    </el-form-item>
                                    <el-form-item label="縣/市" prop="sendInfo.city">
                                        <el-select v-model="form.sendInfo.city" placeholder="縣市"
                                                   @change="checnagSendTown(form.sendInfo.city)">
                                            <el-option v-for="county in counties" :label="county.text"
                                                       :value="county.id"
                                                       :key="county.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="鄉鎮市區" prop="sendInfo.area">
                                        <el-select v-model="form.sendInfo.area" placeholder="鄉鎮市區"
                                                   @change="setLikeBuyfalse">
                                            <el-option v-for="town in sendTowns" :label="town.text" :value="town.id"
                                                       :key="town.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="地址" prop="sendInfo.address">
                                        <el-input v-model="form.sendInfo.address" placeholder="地址"
                                                  @input="setLikeBuyfalse"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="row  mx-2">
                                <div class="col-12 my-4 justify-content-center d-flex">
                                    <el-checkbox label="記錄相關資訊下次使用" name="type"
                                                 v-model="remeber"></el-checkbox>
                                </div>
                            </div>
                            <div>
                                <form method="post" ref="payForm">
                                    <input type="hidden" name="MerchantID"><br>
                                    <input type="hidden" name="TradeInfo"><br>
                                    <input type="hidden" name="TradeSha"><br>
                                    <input type="hidden" name="Version" value="2.0"><br>
                                </form>
                            </div>
                        </div>

                    </el-form>
                </div>
            </div>
        </div>
        <div class="position-fixed w-100 bg-white shadow-lg" style="bottom: 0px;height: 70px;">
            <div class="d-flex justify-content-around align-items-center h-100 ">
                <el-button v-if="active==0" type="primary" @click="goToInfo" class="w-75" :loading="loading"
                           :disabled="!next">下一步
                </el-button>
                <el-button v-if="active==1" type="danger" @click="checkout()" class="w-75" :loading="loading">結帳
                </el-button>
            </div>
        </div>

        <el-dialog
            title="常用資訊" :visible.sync="dialogVisible" width="90%">
            <div class="row mt-3" v-for="(memberInfo,index) in memberInfos" :key="index">
                <div class="col-3">
                    <div class="d-flex justify-content-center align-items-center h-100">
                        <el-button type="info" plain size="mini" class="w-100  m-0" @click="changeInfo(index)">選擇
                        </el-button>
                    </div>
                </div>
                <div class="col-7">
                    <div class="h-100 d-flex flex-column  justify-content-center">
                        <span class="mb-2" style="font-size: 1rem">{{ memberInfo.name }} {{ memberInfo.phone }}</span>
                        <span v-text="buildAddress(memberInfo.countyId,memberInfo.townId,memberInfo.address)"></span>
                    </div>
                </div>
                <div class="col-2">
                    <el-button type="danger" icon="el-icon-delete" circle
                               @click="deleteMemberInfo(memberInfo.id,index)"></el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
            </span>
        </el-dialog>
    </div>

</template>
<style>
.products_check .el-checkbox__label {
    display: none;
}
</style>
<script>


import FN from '@/components/fn'

export default {
    components: {},
    mixins: [FN],
    data() {
        return {
            num: 1,
            value: 1,
            active: 0,
            isIndeterminate: [],
            checkAll: [],
            checkedProducts: [],
            test: false,
            shoppingCars: [],
            loading: true,
            deliveryFees: [],
            totalAmount: 0,
            totalNumber: 0,
            productIds: [],
            counties: [],
            towns: [],
            buyTowns: [],
            sendTowns: [],
            remeber: false,
            memberInfos: [],
            dialogVisible: false,
            infoTyep: 1,
            setLikeBuy: false,
            next: false,
            form: {
                buyInfo: {
                    name: "",
                    phone: "",
                    city: "",
                    address: "",
                    area: "",
                    companyName: "",
                    companyCode: "",
                    email: "",
                },
                sendInfo: {
                    name: "",
                    phone: "",
                    city: "",
                    address: "",
                    area: "",
                },
            },
            rules: {
                buyInfo: {
                    name: [
                        {required: true, message: '請輸入姓名', trigger: 'blur'},
                    ],
                    phone: [
                        {required: true, message: '請輸入聯絡電話', trigger: 'blur'},
                    ],
                    city: [
                        {required: true, message: '請選擇縣/市', trigger: 'change'},
                    ],
                    area: [
                        {required: true, message: '請選鄉鎮市區', trigger: 'change'},
                    ],
                    address: [
                        {required: true, message: '請輸入地址', trigger: 'blur'},
                    ],
                    email: [
                        {type: 'email', required: true, message: 'email格式不正確', trigger: 'blur'},

                    ],

                },
                sendInfo: {
                    name: [
                        {required: true, message: '請輸入姓名', trigger: 'blur'},
                    ],
                    phone: [
                        {required: true, message: '請輸入聯絡電話', trigger: 'blur'},
                    ],
                    city: [
                        {required: true, message: '請選擇縣/市', trigger: 'change'},
                    ],
                    area: [
                        {required: true, message: '請選鄉鎮市區', trigger: 'change'},
                    ],
                    address: [
                        {required: true, message: '請輸入地址', trigger: 'blur'},
                    ],
                },

            },
        }
    },
    mounted() {
        this.getBuyInfo();
        this.getCounties();
        this.getTowns();
        this.getShoppingCar();

    },
    methods: {
        /**
         * 回上一頁
         * */
        back() {
            if (this.active > 0) {
                this.active -= 1;
            } else {
                this.$router.go(-1)
            }
        },
        /**
         * 到資訊頁
         * */
        goToInfo() {
            this.active = 1;
        },
        /**
         * 全選連動處理
         */
        handleCheckAllChange(manufacturerId) {
            var checkAll = this.checkAll[manufacturerId]
            let checkType = (checkAll) ? 1 : 0;
            let preoducts = Object.values(this.productIds[manufacturerId]);
            this.checkedProducts[manufacturerId] = checkAll ? this.productIds[manufacturerId] : [];
            this.isIndeterminate[manufacturerId] = false;
            this.modifyProductsCheck(preoducts, checkType)
            for (let i = 0; i < preoducts.length; i++) {
                this.updateProductCheckStatus(preoducts[i], checkType);
            }
            this.setTotalCount()


        },
        /**
         * 取得購物車資料
         * */
        getShoppingCar() {
            this.FETCH({
                key: 'GET_SHOPPING_CAR',
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getShoppingCar);
                } else if (+(res || {}).code === 0) {
                    this.handelShoppingCarResponse(res);
                } else {
                    this.$message('取得購物車錯誤。');
                }
                this.loading = false

            })
        },
        /**
         * 組購物車資料
         * */
        handelShoppingCarResponse(res) {
            // if (res.data.length > 0) {
            //     this.next = true;
            // }
            var checkAll = [];
            var isIndeterminate = [];
            var checkedProducts = [];
            var productIds = [];

            // 建立全選check array
            res.data.forEach(function (manufacturer) {
                isIndeterminate[manufacturer.id] = checkAll[manufacturer.id] = false;
                checkedProducts[manufacturer.id] = [];
                productIds[manufacturer.id] = [];
                manufacturer.products.forEach(function (product) {
                    if ((product.status != 2 || product.status != 3)) {
                        productIds[manufacturer.id].push(product.productId);
                    }
                    if (product.isChecked == 1) {
                        checkedProducts[manufacturer.id].push(product.productId);
                    }
                });

            });
            this.shoppingCars = res.data;
            this.checkAll = checkAll;
            this.isIndeterminate = isIndeterminate;
            this.checkedProducts = checkedProducts;
            this.productIds = productIds;
            this.setTotalCount();
            this.setAllcheckedStatus();


        },
        /**
         * 異動購物車商品
         */
        modifyShoppingCar(productId, total, manufacturerId) {
            // 是否勾選
            var isChecked = (Object.values(this.checkedProducts[manufacturerId]).includes(productId)) ? 1 : 0;
            this.callModifyShoppingCar(2, productId, total, isChecked)
            this.setTotalCount();
        },
        /**
         * 異常圖片預設網址
         */
        imgError(event) {
            event.target.src = require('@/assets/img_error.svg');
        },
        /**
         * 刪除購物車商品
         */
        deleteShoppingCar(manufacturerId, productId) {
            this.callModifyShoppingCar(3, productId, 0);
            this.shoppingCars.forEach(function (manufacturer, index, object) {
                manufacturer.products.forEach(function (product, index, object) {
                    if (product.productId == productId) {
                        object.splice(index, 1);
                    }
                })
                if (manufacturer.products.length == 0) {
                    object.splice(index, 1);
                }

            })
            this.setTotalCount();
        },
        /**
         * 呼叫異動購物車功能
         */
        callModifyShoppingCar(type, productId, total, isChecked) {
            var typeName = '';
            switch (type) {
                case 2:
                    typeName = '更新';
                    break
                case 3:
                    typeName = '刪除';
                    break
            }
            this.FETCH({
                key: 'MODIFY_SHOPPING_CAR',
                productId: productId,
                number: total,
                type: type,
                checked: isChecked
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.callModifyShoppingCar((type, productId, total, isChecked)));
                } else if (+(res || {}).code > 0) {
                    this.$message(typeName + '購物車商品失敗。');
                }
                this.getShoppingCarCount();

            });
        },
        /**
         * 取得購物車商品數量
         */
        getShoppingCarCount() {
            this.FETCH({
                key: 'GET_SHOPPING_CAR_COUNT',
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getShoppingCarCount);
                }
                this.$root.shoppingCarCount = res.data.count;
            })
        },
        /**
         * 處理單一商品勾選連動
         */
        handleCheckedProductChange(manufacturerId, productId) {
            let productsCount = this.productIds[manufacturerId].length;  //商家商品數量
            let checkedProductCount = this.checkedProducts[manufacturerId].length;  //商家商品選擇數量

            //處理全選連動
            if (checkedProductCount == 0) {
                //沒有選擇則取消模糊勾選為fale
                this.isIndeterminate[manufacturerId] = false;
                this.checkAll[manufacturerId] = false;
            } else if (checkedProductCount == productsCount) {
                //有權選擇全權勾
                this.isIndeterminate[manufacturerId] = false;
                this.checkAll[manufacturerId] = true;
            } else if (productsCount > 0 && checkedProductCount != productsCount) {
                //沒有全選選擇則模糊勾選為true
                this.isIndeterminate[manufacturerId] = true;
            }

            // 是否勾選
            var isChecked = (Object.values(this.checkedProducts[manufacturerId]).includes(productId)) ? 1 : 0;
            this.modifyProductsCheck([productId], isChecked)
            this.updateProductCheckStatus(productId, isChecked)
            this.setTotalCount();

        },
        /**
         * 設定總金額與總數量
         */
        setTotalCount() {
            let count = 0;
            let amount = 0;
            this.setDeliverys();
            this.shoppingCars.forEach(function (manufacturer) {
                manufacturer.products.forEach(function (product) {
                    if (product.isChecked == 1) {
                        count += 1;
                        amount += product.total * product.price
                    }
                })
            });
            this.deliveryFees.forEach(function (deliveryFee) {
                amount += deliveryFee.deliveryFees;
            });

            this.totalAmount = amount;
            this.totalNumber = count;

            if (count > 0) {
                this.next = true;
            } else {
                this.next = false;
            }
        },
        /**
         * 更新購物車商品勾選狀態
         */
        modifyProductsCheck(preoducts, checkType) {
            if (preoducts.length == 0) {
                return "";
            }
            this.FETCH({
                key: 'MODIFY_CHECK_SHOPPING_CAR',
                productIds: preoducts,
                checkType: checkType
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.modifyProductsCheck(preoducts, checkType));
                } else if (+(res || {}).code === 0) {
                    // this.getShoppingCar();
                } else {
                    this.$message('更新購物車商品失敗。');
                }

            });

        },
        /**
         * 設定所有"全部勾選"狀態
         */
        setAllcheckedStatus() {
            let shoppingCars = this.shoppingCars;
            for (let i = 0; i < shoppingCars.length; i++) {
                let manufacturerId = shoppingCars[i].id
                if (this.checkedProducts[manufacturerId].length == this.productIds[manufacturerId].length) {
                    this.checkAll[manufacturerId] = true
                } else if (this.checkedProducts[manufacturerId].length > 0) {
                    this.isIndeterminate[manufacturerId] = true
                } else {
                    this.checkAll[manufacturerId] = false
                    this.isIndeterminate[manufacturerId] = false
                }
            }
        },
        /**
         * 更新vue購物車勾選狀態資料
         * @param productId
         * @param checkType
         */
        updateProductCheckStatus(productId, checkType) {
            this.shoppingCars.forEach(function (manufacturer) {
                manufacturer.products.forEach(function (product) {
                    if (product.productId == productId) {
                        product.isChecked = checkType;
                    }
                })
            })
        },
        /**
         * 取得城市資料
         */
        getCounties() {
            this.FETCH({
                key: 'GET_COUNRIES',
            }).then((res) => {
                this.counties = res;
            });
        },
        /**
         * 取得城市資料
         */
        getTowns() {
            this.FETCH({
                key: 'GET_TOWNS',
            }).then((res) => {
                this.towns = this.buyTowns = this.sendTowns = res;

            });
        },
        /**
         * 設定購買人資訊
         */
        setBuyData() {
            this.infoTyep = 1;
            this.getMemberInfos();
            this.dialogVisible = true
        },
        /**
         * 設定配送資訊
         */
        setSendData() {
            this.infoTyep = 2;
            this.getMemberInfos();
            this.dialogVisible = true
        },
        /**
         * 改變購買資訊的鄉鎮市區
         */
        checnagBuyTown(cityId) {
            this.form.buyInfo.area = "";
            this.FETCH({
                key: 'GET_TOWNS',
                q: cityId,
            }).then((res) => {
                this.buyTowns = res;
            });
            this.setLikeBuy = false;

        },
        /**
         * 改變寄送資訊的鄉鎮市區
         */
        checnagSendTown(cityId) {
            this.form.sendInfo.area = "";
            this.FETCH({
                key: 'GET_TOWNS',
                q: cityId,
            }).then((res) => {
                this.sendTowns = res;
            });
            this.setLikeBuyfalse();

        },
        /**
         * 設定配送資訊與發票寄送資訊相同
         */
        setLikeBuyData() {
            if (this.setLikeBuy) {
                this.sendTowns = this.buyTowns;
                this.form.sendInfo.name = this.form.buyInfo.name;
                this.form.sendInfo.phone = this.form.buyInfo.phone;
                this.form.sendInfo.city = this.form.buyInfo.city;
                this.form.sendInfo.address = this.form.buyInfo.address;
                this.form.sendInfo.area = this.form.buyInfo.area;
            }
        },
        /**
         * 取得常用資訊
         */
        getMemberInfos() {
            this.FETCH({
                key: 'GET_MEMBER_STORE_INFOS',
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getMemberInfos());
                } else if (+(res || {}).code === 0) {
                    this.memberInfos = res.data;
                } else {
                    console.log(res);
                }

            });
        },
        /**
         * 建立成用資訊地址字串
         */
        buildAddress(countyId, townId, address) {

            let county = this.counties.filter(function (item) {
                return (item.id == countyId);
            });

            let town = this.towns.filter(function (item) {
                return (item.id == townId);
            })
            return county[0].text + town[0].text + address;
        },
        /**
         * 刪除常用資訊
         */
        deleteMemberInfo(id, index) {
            this.memberInfos = this.memberInfos.filter(function (item) {
                return (item.id != id);
            })
            this.FETCH({
                key: 'DELETE_MEMBER_STORE_INFOS',
                id: id
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.deleteMemberInfo(id, index));
                }
            });
        },
        /**
         * 選擇常用資料
         */
        changeInfo(index) {

            switch (this.infoTyep) {
                case 1:
                    this.checnagBuyTown(this.memberInfos[index].countyId)
                    this.form.buyInfo.name = this.memberInfos[index].name;
                    this.form.buyInfo.phone = this.memberInfos[index].phone;
                    this.form.buyInfo.city = this.memberInfos[index].countyId;
                    this.form.buyInfo.address = this.memberInfos[index].address;
                    this.form.buyInfo.area = this.memberInfos[index].townId;
                    break;
                case 2:
                    this.checnagSendTown(this.memberInfos[index].countyId)
                    this.form.sendInfo.name = this.memberInfos[index].name;
                    this.form.sendInfo.phone = this.memberInfos[index].phone;
                    this.form.sendInfo.city = this.memberInfos[index].countyId;
                    this.form.sendInfo.address = this.memberInfos[index].address;
                    this.form.sendInfo.area = this.memberInfos[index].townId;
                    break;
            }
            this.setLikeBuy = false;
            this.dialogVisible = false;
        },
        /**
         * 與發票寄送資訊相同選項取消勾選
         */
        setLikeBuyfalse() {
            this.setLikeBuy = false;
        },
        /**
         * 結帳
         */
        checkout() {
            this.$refs.infoForm.validate((valid) => {
                if (valid) {
                    this.FETCH({
                        key: 'STORE_CHECKOUT',
                        companyName: this.form.buyInfo.companyName,
                        companyCode: this.form.buyInfo.companyCode,
                        sendInfoName: this.form.sendInfo.name,
                        sendInfoPhone: this.form.sendInfo.phone,
                        sendInfoCityId: this.form.sendInfo.city,
                        sendInfoAreaId: this.form.sendInfo.area,
                        sendInfoAddress: this.form.sendInfo.address,
                        buyInfoName: this.form.buyInfo.name,
                        buyInfoPhone: this.form.buyInfo.phone,
                        buyInfoCityId: this.form.buyInfo.city,
                        buyInfoAreaId: this.form.buyInfo.area,
                        buyInfoAddress: this.form.buyInfo.address,
                        remeber: this.remeber,
                        email: this.form.buyInfo.email,

                    }).then((res) => {
                        if (+(res || {}).code === -3) {
                            this.checkNewToken(this.checkout());
                        } else if (+(res || {}).code === 0) {
                            this.dontOpenExternal(true);
                            this.$router.replace({name: "CustomerCenter"});
                            this.$refs.payForm.MerchantID.value = res.data.merchantID;
                            this.$refs.payForm.TradeInfo.value = res.data.tradeInfo;
                            this.$refs.payForm.TradeSha.value = res.data.tradeSha;
                            this.$refs.payForm.action = res.data.payUrl;
                            this.$refs.payForm.submit();
                        } else {
                            this.$message('連線異常，請稍後重試');
                        }
                    });
                } else {
                    this.$message.error('請輸入必填資訊。');
                    return false;
                }
            });
        },
        /**
         * 取得購買人歷史資訊
         */
        getBuyInfo() {
            this.FETCH({
                key: 'GET_BUY_INFO',
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getBuyInfo());
                } else if (+(res || {}).code === 0) {
                    this.form.buyInfo.name = res.data.name;
                    this.form.buyInfo.phone = res.data.phone;
                    this.form.buyInfo.city = res.data.countyId;
                    this.form.buyInfo.address = res.data.address;
                    this.form.buyInfo.area = res.data.townId;
                    this.form.buyInfo.companyName = res.data.invoiceTitle;
                    this.form.buyInfo.companyCode = res.data.companyNumber;
                    this.form.buyInfo.email = res.data.email;

                    this.form.sendInfo.name = res.data.sendName;
                    this.form.sendInfo.phone = res.data.sendPhone;
                    this.form.sendInfo.city = res.data.sendCountyId;
                    this.form.sendInfo.address = res.data.sendAddress;
                    this.form.sendInfo.area = res.data.sendTownId;
                }
            });
        },
        /**
         * 停用跳出app功能
         * @param status
         */
        dontOpenExternal(status) {
            try {
                window.flutter_inappwebview.callHandler('dontOpenExternal', status).then(function (success) {
                    console.log('停用跳出app功能執行狀態', success);
                })
            } catch (e) {
                console.log('停用跳出app功能-錯誤', e);
            }
        },
        /**
         * 設定運費
         */
        setDeliverys() {
            var deliveryFees = [];
            this.shoppingCars.forEach(function (manufacturer) {
                var isFreeDelivery = manufacturer.isFreeDelivery;   // 是否有免運
                var freeDelivery = manufacturer.freeDelivery;   // 免運門檻
                var check_total_amount = 0;  //  勾選商品的金額
                manufacturer.products.forEach(function (product) {
                    console.log(product.total);
                    console.log(product.price);
                    if (product.isChecked == 1 && product.status == 1 && isFreeDelivery == 1) {
                        check_total_amount += product.price * product.total;
                    }
                });

                deliveryFees[manufacturer.id] = [];
                deliveryFees[manufacturer.id]['deliveryFee'] = manufacturer.deliveryFee;
                deliveryFees[manufacturer.id]['freeDelivery'] = freeDelivery;
                deliveryFees[manufacturer.id]['isFreeDelivery'] = isFreeDelivery;
                deliveryFees[manufacturer.id]['deliveryFees'] = manufacturer.deliveryFee;

                if (manufacturer.isFreeDelivery == 1 && (check_total_amount >= freeDelivery)) {
                    deliveryFees[manufacturer.id]['deliveryFees'] = 0;
                }

            });
            this.deliveryFees = deliveryFees;
        }

    }
}
</script>




